import { render, staticRenderFns } from "./EditEmailModal.vue?vue&type=template&id=8e328a24&scoped=true"
import script from "./EditEmailModal.vue?vue&type=script&lang=js"
export * from "./EditEmailModal.vue?vue&type=script&lang=js"
import style0 from "./EditEmailModal.vue?vue&type=style&index=0&id=8e328a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e328a24",
  null
  
)

export default component.exports